import React from "react";
import { Heading } from "web/react/emo/heading";
import { Modal } from "web/react/emo/modal";
import { View } from "web/react/emo/view";
import * as styles from "./storefront-info-modal.css";

interface StorefrontInfoModalProps {
    title: string;
    isOpen: boolean;
    onClose: () => void;
    children: React.ReactNode;
}

export function StorefrontInfoModal({
    title,
    isOpen,
    onClose,
    children,
}: StorefrontInfoModalProps): JSX.Element {
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <View className={styles.container} dataTestId="storefront-info-modal">
                <View className={styles.titleSection} marginBottom="sm">
                    <Heading textStyle="subhead">{title}</Heading>
                </View>
                <View marginBottom="sm" className={styles.divider} />
                <View marginBottom="sm" className={styles.contentContainer}>
                    {children}
                </View>
            </View>
        </Modal>
    );
}
